"use strict";

require("phoenix_html");

require("turbolinks");
